import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LaneSheetMeetEventRelayTeamsStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
};

const LaneSheetMeetEventRelayTeamsContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LaneSheetMeetEventRelayTeamsStateContext.Provider value={stateHook}>
      {children}
    </LaneSheetMeetEventRelayTeamsStateContext.Provider>
  );
};

export default LaneSheetMeetEventRelayTeamsContextProvider;